/**
 * @flow
 * @relayHash a734aa110b7f215481c0face295c5af7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type VipAccountManagerLinkRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchRep",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VipAccountManagerLinkRefetchQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "VipAccountManagerLink_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "fetchRep",
                "variableName": "fetchRep",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType"
  },
  "id": "dibs-buyer-layout/173.2.1-2018-06-20T22:36:00.464Z/VipAccountManagerLinkRefetchQuery",
  "kind": "Batch",
  "metadata": {},
  "name": "VipAccountManagerLinkRefetchQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchRep",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "VipAccountManagerLinkRefetchQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRep",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "relationshipType",
                    "value": "VIP",
                    "type": "relationshipType!"
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds",
                    "type": "[String]!"
                  }
                ],
                "concreteType": "UserRelationship",
                "name": "userRelationships",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "name": "userDataB",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "formatType",
                                "value": "INTERNATIONAL",
                                "type": "formatPhoneNumberTypes"
                              }
                            ],
                            "name": "phoneNumber",
                            "storageKey": "phoneNumber{\"formatType\":\"INTERNATIONAL\"}"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "email",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
